export const DomUid = () => {
    return `ruid-${Math.ceil(Math.random() * 10000000)}`;
};



// WEBPACK FOOTER //
// ./src/components/libs/dom-uid.tsx